import { render, staticRenderFns } from "./ReviewPageAI.vue?vue&type=template&id=03950bcf&scoped=true"
import script from "./ReviewPageAI.vue?vue&type=script&lang=js"
export * from "./ReviewPageAI.vue?vue&type=script&lang=js"
import style0 from "./ReviewPageAI.vue?vue&type=style&index=0&id=03950bcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03950bcf",
  null
  
)

export default component.exports